module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.41940db3.ttf";